var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTooltipArrow = function SvgTooltipArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 7",
    width: 11,
    height: 7
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.7 5.7 0 0h11L6.3 5.7a1 1 0 0 1-1.6 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.4,
    d: "M0 0h1.5l4 4.7 4-4.7H11L6.3 5.7a1 1 0 0 1-1.6 0L0 0z"
  })));
};
export default SvgTooltipArrow;